<template>
    <div id="infobox-form" class="gj_right" style="min-height: 0px;">
      <div class="add_con_man">
        * 请尽快完善个人资料，否则相关功能（如：获取学时证书）可能无法使用
        <form novalidate data-vv-scope="form" style="min-height: auto; padding-top: 0px;">
          <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <tbody>
              <tr>
                <td align="right"><b>*</b>姓名：</td>
                <td class="pl_10" style="position: relative;">
                  <input type="text" name="name" class="put_add_text" placeholder="姓名" v-validate="'required'" v-model="form.name">
                  <label class="error_msg" style="position: absolute; left: 300px; width: 40px;">{{ errors.first('form.name') }}</label>
                </td>
                <td rowspan="4" align="right" style="position: relative; border-bottom: 0; padding-right: 10px;">
                  <img v-if="form.photo && form.photo!==''" :src="form.photo"  width="151" height="151"/>
                  <UploadOSS :uploadOSSConf="uploadOSSConf" :DOM_ID="'photo'" v-if="uploadOSSConf.STS!=null" @success = "OSSUploadSuccess"></UploadOSS>
                </td>
              </tr>
              <tr>
                <td width="74" align="right"><b>*</b>身份证：</td>
                <td width="360" class="pl_10" style="position: relative;">
                  <input type="text" name="idCard" class="put_add_text" placeholder="身份证号" v-validate="'required|idcard'" v-model="form.idCard">
                  <label class="error_msg" style="position: absolute; left: 300px; width: 40px;">{{ errors.first('form.idCard') }}</label>
                </td>
              </tr>
              <tr>
                <td align="right">性别：</td>
                <td class="pl_10">
                  <div style="float: left; padding-left: 24px;">
                    <input class="userinfo_radio" type="radio" name="sex" value="0" v-model="form.sex"> 男　
                    <input class="userinfo_radio" type="radio" name="sex" value="1" v-model="form.sex"> 女
                  </div>
                </td>
              </tr>
              <tr>
                <td align="right" class="bt2_10">手机：</td>
                <td class="bt2_10 pl_10">
                  <label></label>
                  <input type="text" name="mobile" class="put_add_text" v-model="form.mobile">
                </td>
              </tr>
              <tr>
                <td align="right"  class="bt_10">邮箱：</td>
                <td class="bt_10 pl_10"><input type="text" name="email" class="put_add_text" v-model="form.email"></td>
              </tr>
            </tbody>
          </table>
          <span v-if="hasCheckBox"><input type="checkbox" style="opacity: 1;" v-model="form.checked" @click="rme(form.checked)"> 不再提醒</span>
        </form>
      </div>
    </div>
</template>

<script>
  import UploadOSS from '@/components/common/upload/uploadOSS.vue'
  import { getCookie, saveCookie, removeCookie } from '@/store/cookies.js'
  import '@/utils/validator.js'
    export default {
      components: { UploadOSS },
      props: ['params'],
      data () {
        return {
          outputs: {
            isValidate: false
          },
          form: {},
          uploadOSSConf: { showMode: '1', style: 'img_upload4', typeArr: 'image/png,image/jpg,image/jpeg', catalog: 'byl', fileName: '', maxSize: '2000000', STS: null }
        }
      },
      computed: {
        hasCheckBox () {
          if (this.params.inputs.showCheckBox) {
            return this.params.inputs.showCheckBox
          }
          return false
        }
      },
      created () {
      },
      mounted () {
        this.getSTS()
        this.OSSUploadSuccess()
        if (this.params.inputs.data && this.params.inputs.data.length > 0) { // 编辑
          this.$validator.pause()
          this.form = this.params.inputs.data[0]
          this.outputs.data = this.form
          this.$nextTick(() => {
            this.$validator.resume()
          })
        } else { // 新增
          this.outputs = {
            data: this.form
          }
        }
      },
      watch: {
        form: {
          handler: function (val, oldVal) {
            this.$validator.validateAll('form').then((result) => {
              this.outputs.isValidate = result
              this.outputs.data = val
            })
            if (this.form.photo) {
              setTimeout(function () {
                $(function () {
                  $('#infobox-form a.img_upload4').css({'background': 'transparent', 'width': '0', 'height': '0'})
                  $('#infobox-form input.img_upload4').css({'width': '151px', 'height': '151px'})
                })
              }, 1000)
            } else {
              setTimeout(function () {
                $(function () {
                  $('#infobox-form a.img_upload4').css({'background': '', 'width': '151px', 'height': '151px'})
                })
              }, 1000)
            }
          },
          deep: true
        }
      },
      methods: {
        OSSUploadSuccess (r) {
          if (r && r != '') {
            this.$set(this.form, r.dom_id, r.res.requestUrls[0])
            $('a.img_upload4').css({'background': 'none', 'width': '0', 'height': '0'})
            $('input.img_upload4').css({'width': '151px', 'height': '151px'})
          }
        },
        getSTS () {
          this.$api.get(this.$global.resourceApiPath, '/common/getSTS', {}, r => {
            let STS = [r.data.expiration, r.data.accessKeyId, r.data.accessKeySecret, r.data.securityToken, r.data.endpointClean, r.data.bucket, r.data.region]
            this.uploadOSSConf.STS = STS
          })
        },
        rme (checked) {
          if (checked) {
            removeCookie('ifrm_031')
          } else {
            saveCookie('ifrm_031', '1')
          }
        }
      }
    }
</script>
<style scoped>
  .px_add_con table thead tr { background: none; }
  .userinfo_radio { opacity: 1; }
</style>



// WEBPACK FOOTER //
// src/components/byl/InfoBox/index.vue